"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TokenRenderers_1 = require("./TokenRenderers");
var dynamic_1 = require("@vanilla-extract/dynamic");
var Resizeable_css_1 = require("./TokenRenderers/Resizeable.css");
var classnames_1 = __importDefault(require("classnames"));
var Alignable_css_1 = require("./TokenRenderers/Alignable.css");
var GetCommonConfigByType_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetCommonConfigByType");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var IsResizeableWidget_1 = require("@CommonFrontend/WidgetRegistry/Utils/IsResizeableWidget");
var IsAlignableWidget_1 = require("@CommonFrontend/WidgetRegistry/Utils/IsAlignableWidget");
var HasTrait_1 = require("@CommonFrontend/WidgetRegistry/Utils/HasTrait");
var widgetStyle_1 = require("Utils/widgetStyle");
var lodash_1 = require("lodash");
var fontSizeMapping_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/fontSizeMapping");
var ColorProvider_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorProvider");
var DefaultBrandColors_1 = __importDefault(require("@CommonFrontendBackend/Account/Brand/DefaultBrandColors"));
var DefaultColors_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/DefaultColors");
var GetBlockStyle_1 = require("@CommonFrontendBackend/StyleServiceV2/GetBlockStyle");
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var FontUtils_1 = require("@CommonFrontendBackend/Utils/FontUtils");
var Layout_css_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgets/Layout.css");
var BRAND_COLOR_DEFAULTS = __spreadArray([
    { themeIndex: 0, value: DefaultBrandColors_1.default.brand },
    { themeIndex: 1, value: DefaultBrandColors_1.default.complementary }
], __read(DefaultColors_1.allDefaultColors), false);
var tokenRenderer = function (tokens, options) {
    var html = "";
    if (!tokens || !tokens.length) {
        return html;
    }
    var currentBlock = null;
    var innerHtml = "";
    var currentIndex = 0;
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type == "block") {
            if (currentBlock != undefined) {
                html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
                innerHtml = "";
            }
            currentBlock = token;
            currentIndex = i;
        }
        else if (token.type == "inline") {
            innerHtml += renderInline(token, currentIndex, tokens, innerHtml, options);
        }
    }
    if (currentBlock) {
        html += renderBlock(currentBlock, currentIndex, tokens, innerHtml, options);
    }
    else {
        html = innerHtml;
    }
    return html;
};
var makeStylableAttributes = function (token, options) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: token.subType, traitName: "styleable" });
    if (styleableConfig) {
        var style_1 = {};
        var blockStyle = (_b = options === null || options === void 0 ? void 0 : options.blockStyles) === null || _b === void 0 ? void 0 : _b[styleableConfig.styleKey];
        var colorProvider = (_c = options.colorProvider) !== null && _c !== void 0 ? _c : new ColorProvider_1.ColorProvider({ allColors: BRAND_COLOR_DEFAULTS });
        var overrides = "style" in token ? token["style"] : null;
        var rawStyleObject = (0, widgetStyle_1.widgetStyle)({
            blockStyle: blockStyle,
            colorProvider: colorProvider,
            overrides: overrides,
            styleableConfig: styleableConfig,
            paragraphBlockStyle: (_d = options["blockStyles"]) === null || _d === void 0 ? void 0 : _d["p"],
            heading2BlockStyle: (_e = options["blockStyles"]) === null || _e === void 0 ? void 0 : _e["h2"],
        });
        var _loop_1 = function (property) {
            if (property.type === "color" && property.variable) {
                var rawColor = (0, lodash_1.get)(rawStyleObject, property.path);
                style_1[property.variable] = rawColor.abs;
            }
            if (property.type === "enumerable") {
                var selectedEnum_1 = (_f = (0, lodash_1.get)(rawStyleObject, property.path)) !== null && _f !== void 0 ? _f : property.defaultValue;
                var stylesToApply = property.options.find(function (option) { return option.value === selectedEnum_1; });
                if (stylesToApply) {
                    (_g = stylesToApply.applies) === null || _g === void 0 ? void 0 : _g.forEach(function (_a) {
                        var variable = _a.variable, value = _a.value;
                        style_1[variable] = value;
                    });
                }
            }
            if (property.type === "numerical" && property.variable) {
                var val = (_h = (0, lodash_1.get)(rawStyleObject, property.path)) !== null && _h !== void 0 ? _h : property.defaultValue;
                style_1[property.variable] = "".concat(val).concat((_j = property.suffix) !== null && _j !== void 0 ? _j : "");
            }
            if (property.type === "alignable" && property.variable) {
                style_1[property.variable] = (0, lodash_1.get)(rawStyleObject, property.path);
            }
            if (property.type === "textLabel" && property.variable) {
                style_1[property.variable] = "\"".concat((0, lodash_1.get)(rawStyleObject, property.path), "\"");
            }
            if (property.type === "fontFamily" && property.variable) {
                var fontFamilyStyle = (0, lodash_1.get)(rawStyleObject, property.path);
                if (fontFamilyStyle.fontStyleType === "Brand") {
                    style_1[property.variable] = FontUtils_1.brandFontCSSVarMap[fontFamilyStyle.brandFontRef];
                }
                else {
                    style_1[property.variable] = fontFamilyStyle.iFont.name;
                }
            }
            if (property.type === "fontSize" && property.variable) {
                if ((_k = (0, lodash_1.get)(rawStyleObject, property.path)) === null || _k === void 0 ? void 0 : _k.themeRef) {
                    style_1[property.variable] =
                        fontSizeMapping_1.fontSizeMappings[styleableConfig.styleKey][(0, lodash_1.get)(rawStyleObject, property.path).themeRef];
                }
                else {
                    style_1[property.variable] = (0, lodash_1.get)(rawStyleObject, property.path).abs;
                }
            }
            if (property.type === "fontWeight" && property.variable) {
                var fontWeight = (0, lodash_1.get)(rawStyleObject, property.path);
                style_1[property.variable] = fontWeight;
            }
        };
        try {
            for (var _l = __values(styleableConfig.properties), _m = _l.next(); !_m.done; _m = _l.next()) {
                var property = _m.value;
                _loop_1(property);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_a = _l.return)) _a.call(_l);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return { style: (0, dynamic_1.assignInlineVars)(style_1) };
    }
};
var makeComponentStyle = function (token, options) {
    var _a, _b, _c, _d;
    var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: token.subType, traitName: "styleable" });
    if (!styleableConfig) {
        return {};
    }
    var blockStyle = (_a = options === null || options === void 0 ? void 0 : options.blockStyles) === null || _a === void 0 ? void 0 : _a[styleableConfig.styleKey];
    var overrides = "style" in token ? token["style"] : null;
    var colorProvider = (_b = options.colorProvider) !== null && _b !== void 0 ? _b : new ColorProvider_1.ColorProvider({ allColors: BRAND_COLOR_DEFAULTS });
    return (0, widgetStyle_1.widgetStyle)({
        blockStyle: blockStyle,
        colorProvider: colorProvider,
        overrides: overrides,
        styleableConfig: styleableConfig,
        paragraphBlockStyle: (_c = options["blockStyles"]) === null || _c === void 0 ? void 0 : _c["p"],
        heading2BlockStyle: (_d = options["blockStyles"]) === null || _d === void 0 ? void 0 : _d["h2"],
    });
};
var makeResizeableAttributes = function (token) {
    var _a;
    if ((0, IsResizeableWidget_1.isResizeableWidget)(token)) {
        var resizeableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: token.subType, traitName: "resizeable" });
        (0, tiny_invariant_1.default)(!!resizeableConfig, "Cannot find resizeable trait config for resizeable widget ".concat(token.subType));
        var attributes = { style: {} };
        if (!token.width) {
            return {};
        }
        if (typeof token.width !== "number") {
            attributes.className = (0, Resizeable_css_1.resizeableWidget)({
                width: token.width,
                fullBleedOnMobile: (_a = resizeableConfig.width.fullBleedOnMobile) !== null && _a !== void 0 ? _a : true,
            });
        }
        else {
            attributes.style.width = "".concat(token.width, "%");
            if (!(0, IsAlignableWidget_1.isAlignableWidget)(token)) {
                attributes.style.marginLeft = "auto";
                attributes.style.marginRight = "auto";
            }
        }
        if (token.height) {
            attributes.style.aspectRatio = "1 / calc(".concat(token.height, " * 0.01)");
        }
        return attributes;
    }
};
var makeSpacingShimAttributes = function (token) {
    var traitConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: token.subType, traitName: "spacingShim" });
    if (!traitConfig) {
        return undefined;
    }
    return { className: traitConfig.className };
};
var makeAlignableAttributes = function (token) {
    var _a;
    if ((0, IsResizeableWidget_1.isResizeableWidget)(token)) {
        if (["wide", "full"].includes(token.width)) {
            return undefined;
        }
    }
    if ((0, IsAlignableWidget_1.isAlignableWidget)(token)) {
        var alignableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: token.subType, traitName: "alignable" });
        return {
            className: (0, Alignable_css_1.alignableWidget)({ alignment: (_a = token.alignment) !== null && _a !== void 0 ? _a : alignableConfig.defaultAlignment }),
        };
    }
};
var makeRenderProps = function (token, index, tokens, innerHtml, options) {
    var _a;
    var _b, _c, _d;
    if (options === void 0) { options = {}; }
    var resizeableAttributes = makeResizeableAttributes(token);
    var styleableAttributes = makeStylableAttributes(token, options);
    var spacingShimAttributes = makeSpacingShimAttributes(token);
    var alignableAttributes = makeAlignableAttributes(token);
    var combinedClassNames = (0, classnames_1.default)(alignableAttributes === null || alignableAttributes === void 0 ? void 0 : alignableAttributes.className, resizeableAttributes === null || resizeableAttributes === void 0 ? void 0 : resizeableAttributes.className, spacingShimAttributes === null || spacingShimAttributes === void 0 ? void 0 : spacingShimAttributes.className, {
        "project-block__block-element": token.type === "block" &&
            !(0, HasTrait_1.hasTrait)({ widgetType: token.subType, traitName: "skipContainerAnimation" }),
    }, (_a = {},
        _a[Layout_css_1.widgetShouldConstrainInLayout] = token.type === "block" &&
            !!(0, HasTrait_1.hasTrait)({
                widgetType: token.subType,
                traitName: "constrainInLayout",
            }),
        _a));
    var combinedStyles = __assign(__assign({}, resizeableAttributes === null || resizeableAttributes === void 0 ? void 0 : resizeableAttributes.style), styleableAttributes === null || styleableAttributes === void 0 ? void 0 : styleableAttributes.style);
    var attributes = __assign(__assign(__assign(__assign({}, resizeableAttributes), styleableAttributes), alignableAttributes), { className: combinedClassNames, style: combinedStyles });
    var style = makeComponentStyle(token, options);
    var blockParagraphColor = "#000000";
    if (options.colorProvider && ((_b = options.blockStyles) === null || _b === void 0 ? void 0 : _b["p"])) {
        blockParagraphColor = options.colorProvider.decorateColor((0, GetBlockStyle_1.convertColorObjToColor)(options.blockStyles["p"]["color"]))
            .value;
    }
    return {
        token: token,
        attributes: attributes,
        renderTokens: function (tokens, overrideOptions) { var _a, _b; return (_b = (_a = options.renderTokens) === null || _a === void 0 ? void 0 : _a.call(options, tokens, __assign(__assign({}, options), overrideOptions))) !== null && _b !== void 0 ? _b : ""; },
        innerHtml: innerHtml,
        index: index,
        isPrintMode: (_c = options.isPrintMode) !== null && _c !== void 0 ? _c : false,
        publicPageLink: options.secretLink,
        disableImgix: (_d = options.disableImgix) !== null && _d !== void 0 ? _d : false,
        tokens: tokens,
        sideBySideConfig: options.sideBySide,
        printOrientation: options.printOrientation,
        style: style,
        blockParagraphColor: blockParagraphColor,
        computeForegroundColor: options.computeForegroundColor,
    };
};
var renderBlock = function (token, index, tokens, innerHtml, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var config = (0, GetCommonConfigByType_1.getGenericCommonConfigByType)(token.subType);
    if (config) {
        return config.publicRender(makeRenderProps(token, index, tokens, innerHtml, options));
    }
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown block token subType: ".concat(token.subType));
    }
    return renderer(token, __assign(__assign({}, options), { index: index, innerHtml: innerHtml, tokens: tokens, renderTokens: tokenRenderer, colorProvider: (_a = options.colorProvider) !== null && _a !== void 0 ? _a : new ColorProvider_1.ColorProvider({ allColors: BRAND_COLOR_DEFAULTS }) }));
};
var renderInline = function (token, index, tokens, innerHtml, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var config = (0, GetCommonConfigByType_1.getGenericCommonConfigByType)(token.subType);
    if (config) {
        return config.publicRender(makeRenderProps(token, index, tokens, innerHtml, options));
    }
    var renderer = TokenRenderers_1.tokenToCreateHtml.get(token.subType);
    if (!renderer) {
        throw new Error("Got an unknown inline token subType: ".concat(token.subType));
    }
    return renderer(token, __assign(__assign({}, options), { renderTokens: tokenRenderer, colorProvider: (_a = options.colorProvider) !== null && _a !== void 0 ? _a : new ColorProvider_1.ColorProvider({ allColors: BRAND_COLOR_DEFAULTS }) }));
};
exports.default = tokenRenderer;
